module.exports = __webpack_public_path__ + "static/media/well.2007a8a2.svg";